/* tslint:disable */
import { DeviceUtil } from "./Util/DeviceUtil";
import { MobileStrategy } from "./Strategy/MobileStrategy";
import { DesktopStrategy } from "./Strategy/DesktopStrategy";
var TLSmartWidget = /** @class */ (function () {
    function TLSmartWidget() {
        this._strategy = null;
    }
    Object.defineProperty(TLSmartWidget.prototype, "config", {
        get: function () {
            return null;
        },
        set: function (config) {
            var _this = this;
            this._config = config;
            if (this._config) {
                this.build();
                window.addEventListener('resize', function () { return _this.build(); });
            }
        },
        enumerable: false,
        configurable: true
    });
    TLSmartWidget.prototype.build = function () {
        if (!this._config.groups || this._windowWidth === window.innerWidth) {
            return;
        }
        var strategy = DeviceUtil.isMobile() ? new MobileStrategy(this._config) : new DesktopStrategy(this._config);
        // Виджеты не влезут по высоте, не билдим ничего
        if (window.innerHeight < 420) {
            if (this._strategy) {
                this._strategy.destroy();
                this._strategy = null;
            }
        }
        else {
            if (!this._strategy) {
                this._strategy = strategy;
                this._strategy.build();
            }
            else if (!this._strategy.isSame(strategy)) {
                this._strategy.destroy();
                this._strategy = strategy;
                this._strategy.build();
            }
        }
        this._windowWidth = window.innerWidth;
    };
    return TLSmartWidget;
}());
var config = window.TL && window.TL.SmartWidget && window.TL.SmartWidget.config;
(window.TL = window.TL || {}).SmartWidget = new TLSmartWidget();
if (config) {
    window.TL.SmartWidget.config = config;
}
